import React from "react";
import { bool, func, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomText from "pages/_components/CustomText/CustomText";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { getStatusTagColor } from "util/discounts";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/discounts/_components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import EcheqCheckbox from "./EcheqCheckbox";
import getCellPlacement from "../../../../util/helpers/table";

const EcheqItem = ({ isDesktop, receibedEcheq, handleCheckEcheq, checked, canCheck, disableCheck }) => {
    const alignX = isDesktop ? "center" : "left";
    const alignY = isDesktop ? "center" : "start";
    const conditions = { isDesktop, canCheck };
    const getCellProps = (row, col) => ({ alignX, alignY, ...getCellPlacement(row, col, conditions) });
    return (
        <>
            {canCheck && (
                <GridTable.Data columnStart={1} rowStart={1}>
                    <EcheqCheckbox
                        name={receibedEcheq.cheque_id}
                        checked={checked}
                        disabled={disableCheck}
                        onChange={(value) => handleCheckEcheq(receibedEcheq.cheque_id, value)}
                    />
                </GridTable.Data>
            )}
            <GridTable.Data {...getCellProps(1, 1)}>
                <CustomData
                    titleText="echecks.number"
                    titleTextType="I18N"
                    valueText={receibedEcheq?.cheque_numero}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 2)}>
                <CustomData
                    titleText="Carácter"
                    titleTextType="STRING"
                    valueText={receibedEcheq?.cheque_caracter}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data className="echeq-table__emisor" alignX="center" {...getCellProps(1, 3)}>
                <CustomData
                    titleText="echecks.emisor"
                    titleTextType="I18N"
                    valueText={receibedEcheq?.emisor_razon_social}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data flexDirection="column" alignX="center" {...getCellProps(1, 4)}>
                <CustomData
                    titleText="echecks.document"
                    titleTextType="I18N"
                    valueText={
                        <>
                            <CustomText text="CUIT" />
                            <br />
                            <CustomText text={receibedEcheq?.emisor_cuit} />
                        </>
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 5)}>
                <CustomData
                    titleText="echecks.emit.amountField.label"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount currency={receibedEcheq?.emisor_moneda} quantity={receibedEcheq?.monto} />
                    }
                    valueTextType="STRING"
                    dataClass="echeq-table__amount"
                />
            </GridTable.Data>
            <GridTable.Data {...getCellProps(1, 6)}>
                <CustomData
                    titleText="echecks.datePayed"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={receibedEcheq?.fecha_pago} timeZone="UTC" />}
                    valueTextType="STRING"
                    dataClass="echeq-table__date"
                />
            </GridTable.Data>

            <GridTable.Data
                columnStart={isDesktop ? 8 : 4}
                rowStart={1}
                alignX={isDesktop ? "center" : "end"}
                alignY={isDesktop ? "center" : "start"}>
                <InfoTag
                    type="info"
                    message={receibedEcheq?.estado}
                    tagBackground={getStatusTagColor(receibedEcheq?.estado)}
                    tagClass="discounts-echeq-tag__status"
                />
            </GridTable.Data>
        </>
    );
};

EcheqItem.propTypes = {
    canCheck: bool.isRequired,
    checked: bool.isRequired,
    isDesktop: bool.isRequired,
    handleCheckEcheq: func.isRequired,
    receibedEcheq: shape(echeqPropTypes).isRequired,
    disableCheck: bool.isRequired,
};

export default EcheqItem;
